import { Action } from '@ngrx/store';
import { MsisdnListInterface } from '../../models/msisdn-list.interface';

export enum EMsidnListActions {
  GetMsisdnList = '[MSISDN] Get msidn list',
  GetMsisdnListSuccess = '[MSISDN] Get msidn list success',
  GetMsisdnListFailure = '[MSISDN] Get msidn list failure',
}

export class GetMsisdnList implements Action {
  public readonly type = EMsidnListActions.GetMsisdnList;
  constructor() {}
}

export class GetMsisdnListSuccess implements Action {
  public readonly type = EMsidnListActions.GetMsisdnListSuccess;
  constructor(public payload: Array<MsisdnListInterface>) {}
}

export class GetMsisdnListFailure implements Action {
  public readonly type = EMsidnListActions.GetMsisdnListFailure;
}

export type MsidnListActions = GetMsisdnList | GetMsisdnListSuccess | GetMsisdnListFailure;
